module.exports = __webpack_public_path__ + "img/symbol_7.2d70d6d9.png";